import React, { useState } from 'react';
import './Contact.css';

export default function Contact() {
  const [form, setForm] = useState({ 
    name: '', 
    email: '', 
    phone: '', 
    service: '', 
    budget: '', 
    message: '' 
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = e => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    // Prepare form data for Web3Forms
    const formData = new FormData();
    formData.append('access_key', '5c6669ef-769f-4275-a59d-24e906e16af6');
    formData.append('name', form.name);
    formData.append('email', form.email);
    formData.append('phone', form.phone);
    formData.append('service', form.service);
    formData.append('budget', form.budget);
    formData.append('message', form.message);
    formData.append('subject', `New Contact Form Submission from ${form.name}`);
    formData.append('from_name', form.name);
    
    // Send to this email address
    formData.append('to_email', 'info@laserguided.co.ke');
    
    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formData
      });
      
      const data = await response.json();
      
      if (data.success) {
        setSubmitted(true);
        // Reset form
        setForm({ name: '', email: '', phone: '', service: '', budget: '', message: '' });
      } else {
        alert('Something went wrong. Please try again.');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Failed to send message. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="contact-page">
      {/* Hero */}
      <section className="page-hero">
        <div className="page-hero__glow" />
        <div className="container page-hero__inner">
          <div className="section-header__tag">Contact Us</div>
          <h1 className="page-hero__title">
            Let's Build <span className="text-fire">Something</span><br/>
            Extraordinary
          </h1>
          <p className="page-hero__desc">
            Tell us about your project. We'll get back to you within 24 hours
            with a clear plan of action.
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section">
        <div className="container contact-inner">

          {/* Info Side */}
          <div className="contact-info">
            <h2 className="contact-info__title">Get in Touch</h2>
            <p className="contact-info__desc">
              Whether you have a clear vision or just a spark of an idea — we're here
              to help you target the right path and hit your goals.
            </p>

            <div className="contact-info__items">
              <div className="contact-info__item">
                <div className="contact-info__icon">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
                  </svg>
                </div>
                <div>
                  <div className="contact-info__label">Location</div>
                  <div className="contact-info__val">Eldoret, Kenya 🇰🇪</div>
                </div>
              </div>

              <div className="contact-info__item">
                <div className="contact-info__icon">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
                  </svg>
                </div>
                <div>
                  <div className="contact-info__label">Email</div>
                  <div className="contact-info__val">info@laserguided.co.ke</div>
                </div>
              </div>

              <div className="contact-info__item">
                <div className="contact-info__icon">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2.18h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                  </svg>
                </div>
                <div>
                  <div className="contact-info__label">Phone / WhatsApp</div>
                  <div className="contact-info__val">+254 743 379 990</div>
                </div>
              </div>

              <div className="contact-info__item">
                <div className="contact-info__icon">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
                  </svg>
                </div>
                <div>
                  <div className="contact-info__label">Response Time</div>
                  <div className="contact-info__val">Within 24 hours</div>
                </div>
              </div>
            </div>

            <div className="contact-info__socials">
              {['LinkedIn', 'Twitter', 'GitHub', 'Instagram'].map(s => (
                <a key={s} href="#" className="contact-social">{s}</a>
              ))}
            </div>
          </div>

          {/* Form Side */}
          <div className="contact-form-wrap">
            {submitted ? (
              <div className="contact-success">
                <div className="contact-success__icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
                  </svg>
                </div>
                <h3>Message Received!</h3>
                <p>We've got your message and will be in touch within 24 hours. Get ready — let's build something great.</p>
                <button className="btn btn--fire" onClick={() => { setSubmitted(false); setForm({ name:'',email:'',phone:'',service:'',budget:'',message:'' }); }}>
                  Send Another Message
                </button>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                <h2 className="contact-form__title">Start Your Project</h2>

                <div className="form-row">
                  <div className="form-group">
                    <label>Full Name *</label>
                    <input
                      type="text"
                      name="name"
                      value={form.name}
                      onChange={handleChange}
                      placeholder="John Kariuki"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Email Address *</label>
                    <input
                      type="email"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      placeholder="john@company.com"
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Phone / WhatsApp</label>
                    <input
                      type="tel"
                      name="phone"
                      value={form.phone}
                      onChange={handleChange}
                      placeholder="+254 7XX XXX XXX"
                    />
                  </div>
                  <div className="form-group">
                    <label>Service Needed</label>
                    <select name="service" value={form.service} onChange={handleChange}>
                      <option value="">Select a service...</option>
                      <option value="web">Web Development</option>
                      <option value="systems">Systems Development</option>
                      <option value="app">App Development</option>
                      <option value="design">UI/UX Design</option>
                      <option value="strategy">Digital Strategy</option>
                      <option value="other">Other / Not Sure</option>
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label>Estimated Budget</label>
                  <select name="budget" value={form.budget} onChange={handleChange}>
                    <option value="">Select budget range...</option>
                    <option value="<50k">Under KES 50,000</option>
                    <option value="50-150k">KES 50,000 – 150,000</option>
                    <option value="150-500k">KES 150,000 – 500,000</option>
                    <option value="500k+">KES 500,000+</option>
                    <option value="discuss">Let's discuss</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Tell Us About Your Project *</label>
                  <textarea
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    placeholder="Describe your project, goals, timeline, and anything else we should know..."
                    rows={5}
                    required
                  />
                </div>

                <button type="submit" className={`btn btn--fire contact-submit ${loading ? 'loading' : ''}`} disabled={loading}>
                  {loading ? (
                    <>
                      <div className="btn-spinner" />
                      Sending...
                    </>
                  ) : (
                    <>
                      Send Message
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                        <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>
                      </svg>
                    </>
                  )}
                </button>
              </form>
            )}
          </div>
        </div>
      </section>
    </main>
  );
}